import { AnalyticsBrowser } from "@segment/analytics-next";

let analyticsInstance = null;

export function getLoggedInUser() {
    let user = localStorage.getItem('user')
    let authToken = localStorage.getItem('authToken')

    if (user && authToken) {
        try {
            return JSON.parse(user)
        } catch (e) {
            localStorage.removeItem('user')
            localStorage.removeItem('authToken')
            return null
        }
    } else {
        localStorage.removeItem('user')
        localStorage.removeItem('authToken')
        return null
    }
}

export function getAuthToken() {
    return localStorage.getItem('authToken') || null
}

export function logout({ redirectToLogin }) {
    localStorage.removeItem('user')
    localStorage.removeItem('authToken')
    if (redirectToLogin) {
        window.location.replace('login')
    }
}

export function redirectIfLoggedIn() {
    if (getLoggedInUser() != null) {
        // User is logged in; redirect to the accounts page.
        console.log(`Redirecting to account-overview because the user is logged in.`)
        window.location.replace('account-overview')
    }
}

export async function getAppRuntimeConstants() {
    return new Promise((resolve, reject) => {
        $.ajax({
            method: 'GET',
            url: `${window.apiHost}/api/v1/app/runtime-constants?view=site`,
            dataType: 'json',
            contentType: 'application/json'
        })
            .done(response => {
                // returns at least 
                // { app_latest_version, spark_latest_version }
                resolve(response)
            })
            .catch(e => {
                reject(e)
            })
    })
}

export function updateDownloadLinksWithVersion(app_latest_version, spark_latest_version) {
    const downloadHost = 'https://downloads.musesessions.co'

    // Muse App
    $('a[href$="/Muse-VERSION.dmg"]').attr('href', `${downloadHost}/muse-app/Muse-${app_latest_version}.dmg`)
    $('a[href$="/Muse-arm64-VERSION.dmg"]').attr('href', `${downloadHost}/muse-app/Muse-arm64-${app_latest_version}.dmg`)
    $('a[href$="/MuseSetup-VERSION.exe"]').attr('href', `${downloadHost}/muse-app/MuseSetup-${app_latest_version}.exe`)

    // Spark 
    $('a[href$="/Muse Spark VERSION.dmg"]').attr('href', `${downloadHost}/muse-spark/Muse Spark ${spark_latest_version}.dmg`)
    $('a[href$="/Muse Spark Install VERSION.exe"]').attr('href', `${downloadHost}/muse-spark/Muse Spark Install ${spark_latest_version}.exe`)
}

let country;
export async function getCountryCode() {
    if (!country) {
        try {
            const resp = await fetch(
                `${window.apiHost}/api/v1/requests/ip-info`,
                { method: 'POST' },
            );
            const body = await resp.json();
            country = body.countryCode ?? '??';
        } catch (e) {
            console.error('Failed to fetch country', e);
            country = '??';
        }
    }

    return country;
}

export async function isEuCountry() {
    const euCountryCodes = [
        'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
        'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
        'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE' //, 'KR'
    ]

    const countryCode = await getCountryCode();
    if (euCountryCodes.includes(countryCode)) {
        return true;
    }
}

let fetchCheckoutLinkProimse = null;
export function fetchCheckoutLink(
    priceId,
    authToken,
    successUrl,
    failureUrl,
    promotionCode,
    couponId,
    clientReferenceId,
    catalog = 'spark',
    qty = 1,
    collectShippingAddress = false,
) {
    if (fetchCheckoutLinkProimse) {
        return fetchCheckoutLinkProimse;
    }
    fetchCheckoutLinkProimse = new Promise((resolve, reject) => {
        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/checkout-session`,
            data: JSON.stringify({
                priceId,
                successUrl,
                failureUrl,
                promotionCode: promotionCode || null,
                couponId: couponId || null,
                clientReferenceId,
                catalog,
                qty,
                collectShippingAddress,
            }),
            dataType: 'json',
            contentType: 'application/json',
            headers: {
                Authorization: 'Bearer ' + authToken,
            },
        })
            .done(response => {
                console.log(`getCheckoutLink response=%O`, response)
                resolve(response.url)
            })
            .catch(e => {
                console.log(`getCheckoutLink returned error: %O`, e)
                reject(e)
            })
    });

    return fetchCheckoutLinkProimse;
}

export function fetchProProductPrices(country) {
    return new Promise((resolve, reject) => {
        const url = new URL(`${window.apiHost}/api/v1/product-prices`);
        if (country) {
            url.searchParams.set('country', country);
        }
        $.ajax({
            method: 'GET',
            url: url.toString(),
            dataType: 'json',
            contentType: 'application/json',
        })
            .done(response => {
                console.log(`fetchProProductPrices response=%O`, response)
                resolve(response)
            })
            .catch(e => {
                console.log(`fetchProProductPrices returned error: %O`, e)
                reject(e)
            })
    })
}

export async function onLoginSuccess(token, user, redirect) {
    localStorage.setItem('authToken', token)
    localStorage.setItem('user', JSON.stringify(user))

    const queryParams = new URLSearchParams(window.location.search)
    if (queryParams.has('actionAfterLogin')) {
        const actionAfterLogin = queryParams.get('actionAfterLogin')
        try {
            const parsedAction = JSON.parse(atob(actionAfterLogin))
            console.log(parsedAction)
            if (parsedAction.op === 'stripeCheckout') {
                const { priceId, successUrl, failureUrl, promotionCode,
                    couponId, clientReferenceId, catalog, qty, collectShippingAddress } = parsedAction

                const checkoutLink = await fetchCheckoutLink(
                    priceId, token, successUrl, failureUrl, promotionCode, couponId, clientReferenceId, catalog, qty ?? 1, collectShippingAddress ?? false)

                window.location.replace(checkoutLink)
            } else if (parsedAction.op === 'redirect') {
                const allowedRedirects = ['/muse-holiday-bundles'];
                if (allowedRedirects.includes(parsedAction.url)) {
                    window.location.replace(parsedAction.url);
                } else {
                    console.error('actionAfterLogin redirect URL contains an untrusted host');
                }
            }
        } catch (error) {
            console.error("Error parsing actionAfterLogin:", error);
        }
    } else {
        window.location.replace(redirect)
    }
}

export function getIpInfo() {
    return new Promise((resolve, reject) => {
        const countryCodeOverride = localStorage.getItem('countryCodeOverride')
        if (countryCodeOverride) {
            resolve({ status: 'success', countryCode: countryCodeOverride })
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/requests/ip-info`,
            data: JSON.stringify({}),
            dataType: 'json',
            contentType: 'application/json',
            error: (response) => {
                const code = (response.responseJSON || {}).code
                reject(response.responseJSON || {})
                // console.log('failure code=' + code)
                // if (code === 'no_ip') {
                // } else {
                // }
            }
        })
            .done(async (response) => {
                resolve(response)
            })
    })
}

export function countryCodeToRegionClass(countryCode) {
    const southAmericaCountryCodes = ['AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'GY', 'PY', 'PE', 'SR', 'UY', 'VE']
    if (southAmericaCountryCodes.includes(countryCode)) {
        return 'south_america'
    } else {
        return 'other'
    }
}

export function replaceAddressBarText() {
    let loc = window.location.pathname.replace('index\.html', '')
    loc = loc.replace('\.html', '')
    history.replaceState(null, '', loc)
}

export function strtrim(str) {
    return (str || '').trim()
}

export function strempty(str) {
    if (typeof str !== 'string') {
        return true
    } else {
        return str.trim().length === 0
    }
}

const getAnalyticsInstance = () => {
    try {
      if (!analyticsInstance) {
        const ANALYTICS_WRITE_KEY = process.env.ANALYTICS_WRITE_KEY || "";


        if (!ANALYTICS_WRITE_KEY) {
          throw new Error("ANALYTICS_WRITE_KEY is not defined");
        }
  
        analyticsInstance = AnalyticsBrowser.load({
          writeKey: ANALYTICS_WRITE_KEY,
        });
      }
      return analyticsInstance;
    } catch (error) {
      console.error("Failed to load analytics instance:", error);
    }
  }

export const setAnalyticsIdentity = (userUrn, profile) => {
    const Analytics = process.env.ANALYTICS_WRITE_KEY ? getAnalyticsInstance() : undefined


    if (Analytics) {
      Analytics.identify(userUrn, { ...profile });
    } else {
      console.error("Analytics instance is not available");
    }
}

export const logUserActivity = (
    event,
    username = '',
    additionalData = {}
    ) => {
    const Analytics = process.env.ANALYTICS_WRITE_KEY ? getAnalyticsInstance() : undefined
  

    if (Analytics) {
      Analytics.track(event, {
        username: username,
        ...additionalData,
      });
    } else {
      console.error("Analytics instance is not available");
    }
}
